var React = require('react');

function Bypass (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.6626 7.08091C21.8815 6.84933 22.0027 6.53916 22 6.21722C21.9972 5.89527 21.8708 5.5873 21.6479 5.35964C21.4251 5.13198 21.1236 5.00284 20.8085 5.00005C20.4933 4.99725 20.1897 5.12101 19.963 5.34468L8.99508 16.5275L5.03699 12.4841C4.8103 12.2604 4.50668 12.1367 4.19152 12.1395C3.87637 12.1423 3.5749 12.2714 3.35205 12.4991C3.12919 12.7267 3.00278 13.0347 3.00005 13.3566C2.99731 13.6786 3.11846 13.9888 3.33741 14.2203L8.99508 20L21.6626 7.08091Z","fill":"#1BE3AD"}));
}

Bypass.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Bypass;

Bypass.default = Bypass;
